<template>
  <el-col :span="24">
    <div v-if="post.typeObjet >= 2000 && post.typeObjet < 3000 && post.typeObjet !== 2420 || post.typeObjet === 3300 || post.typeObjet === 4400">
      <el-form-item :label="$labels.surface_commerciale + ' *'" prop="surface_commerciale" v-if="post.typeObjet >= 2300 && post.typeObjet < 2500 && post.typeObjet !== 2410">
        <el-input v-model="post.surface_commerciale">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
      <el-form-item :label="$labels.surface_bureaux + ' *'" prop="surface_bureaux" v-else-if="post.typeObjet === 2410 || post.typeObjet === 3400 || post.typeObjet === 4400">
        <el-input v-model="post.surface_bureaux">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
      <el-form-item :label="$labels.surface_activite + ' *'" prop="surface_activite" v-else>
        <el-input v-model="post.surface_activite">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
    </div>
    <div v-else>
      <el-form-item :label="$labels.surface_terrain + ' *'" prop="surface_terrain" v-if="(post.typeObjet >= 1300 && post.typeObjet < 1400) || post.typeObjet === 3300">
        <el-input v-model="post.surface_terrain">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
      <el-form-item :label="$labels.surface_stationnement + ' *'" prop="surface_stationnement" v-else-if="post.typeObjet >= 1400 && post.typeObjet < 1500">
        <el-input v-model="post.surface_stationnement">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
      <el-form-item :label="$labels.surface_min + ' *'" prop="surface_min" v-else-if="post.typeObjet >= 3000 && post.typeObjet <= 5000 && post.typeObjet != 3400 && post.typeObjet != 4400">
        <el-input v-model="post.surface_min">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
      <el-form-item :label="$labels.surface_habitable + ' *'" prop="surface_habitable" v-else>
        <el-input v-model="post.surface_habitable">
          <div slot="append">m²</div>
        </el-input>
      </el-form-item>
    </div>
  </el-col>
</template>

<script>
import { getUsers } from '@/services/users'
import {mapGetters} from "vuex";

export default {
  name: 'PostFormImmoSurfaceMainTab',
  props: ['create', 'post'],
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>
